define([
    "skylark-utils/http"
], function(http) {
    return http;
});
